/**
 * Resolves with `fallback` when `promise` has not settled within `ms`.
 *
 * Used to keep Capacitor cold start from waiting forever on a native bridge call
 * (`Network.getStatus`, Preferences restore). The iOS bridge is serialized: an awaited hang
 * in a Nuxt plugin prevents the Vue app from mounting (native splash never dismisses).
 */
export function promiseWithTimeout<T, F = undefined>(
    promise: Promise<T>,
    ms: number,
    fallback: F
): Promise<T | F> {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => resolve(fallback), ms)
        promise.then(
            (value) => {
                clearTimeout(timer)
                resolve(value)
            },
            (error: unknown) => {
                clearTimeout(timer)
                reject(error)
            }
        )
    })
}
